import { Input } from '@chakra-ui/react';
import React from 'react';
import { useForm } from 'react-hook-form';

import { ButtonGroup, ButtonIcon, Flex } from 'shared';
import { Icon, iconNames } from 'shared_DEPRECATED/components/Icon';
import Spacer from 'shared_DEPRECATED/components/Spacer';

import { IPlanningDraftSprint } from 'features/planning';
import { useEditDraftSprintTitle } from 'features/planning/hooks/mutation/useEditDraftSprintTitle';

type TPlanningDraftSprintHeaderEditor = {
  sprint: IPlanningDraftSprint;
  onDone: () => void;
};

export const PlanningDraftSprintHeaderEditor = ({
  sprint,
  onDone,
}: TPlanningDraftSprintHeaderEditor) => {
  const { editSprintTitle } = useEditDraftSprintTitle();
  const methods = useForm({
    defaultValues: {
      title: sprint.title!,
    },
  });

  const handleSubmit = methods.handleSubmit((data) => {
    editSprintTitle({
      title: data.title,
      sprintId: sprint.sprintId,
    });
    onDone();
  });

  const handleCancel = () => {
    onDone();
  };

  const handleKeyDown = async (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === 'Enter') {
      e.preventDefault();
      await handleSubmit();
    }
    if (e.key === 'Escape') {
      e.preventDefault();
      handleCancel();
    }
  };

  return (
    <Flex p="0px 16px">
      <Input
        {...methods.register('title')}
        autoFocus={true}
        onKeyDown={handleKeyDown}
      />
      <Spacer size="sm" />
      <ButtonGroup gap="0.5rem" size="sm">
        <ButtonIcon
          aria-label="save"
          data-testid="save-btn"
          variant="ghost"
          onClick={handleSubmit}
          rounded="full"
        >
          <Icon
            name={iconNames.tick}
            width="14px"
            height="14px"
            fill="var(--fgPrimary)"
          />
        </ButtonIcon>
        <ButtonIcon
          aria-label="cancel"
          data-testid="save-btn"
          variant="ghost"
          onClick={handleCancel}
          rounded="full"
        >
          <Icon
            name={iconNames.cross}
            width="14px"
            height="14px"
            fill="var(--fgPrimary)"
          />
        </ButtonIcon>
      </ButtonGroup>
    </Flex>
  );
};
